import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import qrAnalyticsActions from '../../../../store/analyticsStores/qrAnalyticsStore/qrAnalyticsActions';
import QrAnalytics from './QrAnalytics';
import { PENDING } from '../../../../store/globalStatuses/globalStatuses';

function formatDate(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1) < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
    const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    return `${year}-${month}-${day}`;
}

export default function QrAnalyticsContainer() {
    const dispatch = useDispatch();
    const { analytics, status } = useSelector(state => state.qrAnalyticsReducer);
    const { info } = useSelector(state => state.branchReducer);
    const { t } = useTranslation();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    useEffect(() => {
        if (info?.id) {
            let dates = '';
            if (startDate && endDate) {
                dates = `?from=${formatDate(startDate)}&to=${formatDate(endDate)}`;
            }
            dispatch(qrAnalyticsActions.getQrAnalytics(info.id, dates));
        }
    }, [info?.id, startDate, endDate, dispatch]);

    const qrToggle = info?.configuration?.access_toggles?.qr_registration;
    if (info && qrToggle !== undefined && !qrToggle?.enabled) {
        return (
            <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                <p style={{ fontSize: 16, color: '#888' }}>
                    {t('optionForbidden')} <br/>
                    {t('touchModerator')}
                </p>
            </div>
        );
    }

    return (
        <QrAnalytics
            analytics={analytics}
            isLoading={status === PENDING}
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
        />
    );
}
